import styled from "styled-components";

type PageButtonProps = {
  $active?: boolean;
};

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 8px 24px;
  min-height: 44px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: var(--color-neutral-background, #ffffff);
  border-top: 1px solid var(--color-neutral-300, #d9d9d9);
`;

export const PageSizeWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const PageSizeField = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: var(--color-neutral-900, #0e0e0e);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`;

export const PageSizeSelect = styled.select`
  box-sizing: border-box;
  min-width: 64px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--color-neutral-400, #6f6f6f);
  border-radius: 2px;
  background: var(--color-contrast-white, #ffffff);
  color: var(--color-neutral-900, #0e0e0e);
  font-size: 14px;
  line-height: 1;
`;

export const PaginationLabel = styled.span`
  white-space: nowrap;
`;

export const PageButtonGroup = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
`;

export const PageButton = styled.button<PageButtonProps>`
  all: unset;
  box-sizing: border-box;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $active }) => ($active ? "var(--color-contrast-white, #ffffff)" : "var(--color-neutral-700, #474747)")};
  background: ${({ $active }) => ($active ? "var(--color-action-default, #2c589b)" : "transparent")};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  line-height: 1;
  cursor: pointer;
  user-select: none;

  &:hover:not(:disabled) {
    background: ${({ $active }) => ($active ? "var(--color-action-default, #2c589b)" : "rgba(44, 88, 155, 0.08)")};
  }

  &:disabled {
    cursor: default;
    opacity: ${({ $active }) => ($active ? 1 : 0.45)};
  }
`;

export const PaginationInfo = styled.p`
  margin: 0;
  color: var(--color-neutral-700, #474747);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
`;
